import { get } from '../../common/ApiClient';
import { PaymentResponse, AllPaymentResponse } from 'payment/types/Payment';

export const getPayment = async (vs: string): Promise<PaymentResponse> => {
  const { data } = await get<any>('/payments/info', true, {}, { vs });

  return data;
};

export const getAllPayments = async (): Promise<AllPaymentResponse> => {
  const { data } = await get<any>('/payments/all', true);

  return data;
};
